var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 14.7867,
    cy: 14.3872,
    r: 11.0402,
    transform: "rotate(-0.552216 14.7867 14.3872)",
    fill: "#74D976"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6517 0.593896C7.06377 0.66703 0.915306 6.93517 0.988441 14.5231C1.06158 22.111 7.32971 28.2595 14.9176 28.1863C22.5056 28.1132 28.654 21.8451 28.5809 14.2571C28.5077 6.66922 22.2396 0.520761 14.6517 0.593896ZM14.891 25.4271C8.80691 25.4857 3.80633 20.5806 3.74768 14.4965C3.68904 8.41236 8.59415 3.41178 14.6783 3.35314C20.7624 3.2945 25.763 8.19961 25.8216 14.2837C25.8803 20.3679 20.9752 25.3685 14.891 25.4271ZM21.0584 8.23115L12.0543 17.4105L8.44674 13.8855L6.52023 15.8495L12.0919 21.3148L23.0225 10.1715L21.0584 8.23115Z",
    fill: "#74D976"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/Accept.1c93517ce995b87b25e6a767cc42b6ce.svg";
export { ForwardRef as ReactComponent };